













































































import {Component, Watch, Vue} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import UserMenu from './UserMenu.vue';

@Component({
    components: {
        UserMenu,
    },
    computed: {
        ...mapGetters(['user', 'companies', 'equipmentTypes', 'idCurrentCompany', 'isAdmin']),
    },
    methods: {
        ...mapActions('login', ['logout']),
        ...mapActions(['changeCompany']),
    },
})
export default class NavBar extends Vue {
    public user!: any;
    public companies!: any[];
    public equipmentTypes!: any[];
    public isAdmin!: boolean;
    public idCurrentCompany!: number;
    public logout!: Function;
    public changeCompany!: Function;

    private equipmentPiece = [
        {
            name: 'Catalogues.Equipments.EquipmentType.NameSingle',
            path: this.$api.catalogues.equipmentType,
        },
        {
            name: 'Catalogues.Equipments.Settings.SettingsEquipment.NameMultiple',
            path: this.$api.catalogues.equipmentSettings,
        },
        {
            name: 'Catalogues.Equipments.WarehouseVeneerEquipmentTypeLink.NameSingle',
            path: this.$api.catalogues.warehouseVeneerEquipmentTypeLink,
        },
        {
            name: 'Catalogues.Equipments.WarehousePlywoodEquipmentTypeLink.NameSingle',
            path: this.$api.catalogues.warehousePlywoodEquipmentTypeLink,
        },
        {
            name: 'Catalogues.Equipments.PlywoodProductionProcesses.PlywoodProductionDistribution.NameSingle',
            path: this.$api.catalogues.plywoodProductionDistribution,
        },
    ];

    private catalogues = {
        name: 'Main.Catalogues',
        open: false,
        show: true,
        items: [
            {
                name: 'Catalogues.Equipments.Equipment.NameSingle',
                childrens: [...this.equipmentPiece],
            },
            {
                name: 'Main.Wood',
                childrens: [
                    {
                        name: 'Catalogues.WoodSpecie.NameSingle',
                        path: this.$api.catalogues.woodSpecie,
                    },
                ],
            },
            {
                name: 'Catalogues.Veneers.Veneer.NameSingle',
                childrens: [
                    {
                        name: 'Catalogues.Veneers.VeneerOuterGrade.NameSingle',
                        path: this.$api.catalogues.veneerOuterGrade,
                    },
                    {
                        name: 'Catalogues.Veneers.VeneerSize.NameSingle',
                        path: this.$api.catalogues.veneerSize,
                    },
                    {
                        name: 'Catalogues.Veneers.VeneerThickness.NameSingle',
                        path: this.$api.catalogues.veneerThickness,
                    },
                    {
                        name: 'Catalogues.Veneers.VeneerSpecie.NameSingle',
                        path: this.$api.catalogues.veneerSpecie,
                    },
                    {
                        name: 'Catalogues.Veneers.VeneerWetness.NameSingle',
                        path: this.$api.catalogues.veneerWetness,
                    },
                    {
                        name: 'Catalogues.Veneers.VeneerMaxUsedShiftCountOfStorage.NameSingle',
                        path: this.$api.catalogues.veneerMaxUsedShiftCountOfStorage,
                    },
                    {
                        name: 'Catalogues.Veneers.VeneerPatchingGrade.NameSingle',
                        path: this.$api.catalogues.veneerPatchingGrade,
                    },
                    {
                        name: 'Catalogues.Veneers.Veneer.NameSingle',
                        path: this.$api.catalogues.veneer,
                    },
                ],
            },
            {
                name: 'Main.Plywood',
                childrens: [
                    {
                        name: 'Catalogues.Plywoods.PlywoodSize.NameSingle',
                        path: this.$api.catalogues.plywoodSize,
                    },
                    {
                        name: 'Catalogues.Plywoods.PlywoodThickness.NameSingle',
                        path: this.$api.catalogues.plywoodThickness,
                    },
                    {
                        name: 'Catalogues.Plywoods.PlywoodGrade.NameSingle',
                        path: this.$api.catalogues.plywoodGrade,
                    },
                    {
                        name: 'Catalogues.Plywoods.PlywoodSpecie.NameSingle',
                        path: this.$api.catalogues.plywoodSpecie,
                    },
                    {
                        name: 'Catalogues.Plywoods.PlywoodSurface.NameSingle',
                        path: this.$api.catalogues.plywoodSurface,
                    },
                    {
                        name: 'Catalogues.Plywoods.PlywoodWaterResistance.NameSingle',
                        path: this.$api.catalogues.plywoodWaterResistance,
                    },
                    {
                        name: 'Catalogues.ComplectationRule.NameMultiple',
                        path: this.$api.catalogues.complectationRule,
                    },
                ],
            },
            {
                name: 'Catalogues.Warehouses.Warehouse.NameSingle',
                childrens: [
                    {
                        name: 'Catalogues.Warehouses.WarehousePlywood.NameSingle',
                        path: this.$api.catalogues.warehousePlywood,
                    },
                    {
                        name: 'Catalogues.Warehouses.WarehouseVeneer.NameSingle',
                        path: this.$api.catalogues.warehouseVeneer,
                    },
                ],
            },
            {
                name: 'Catalogues.ShiftTml.Shift',
                childrens: [
                    {
                        name: 'Catalogues.ShiftTml.NameSingle',
                        path: this.$api.catalogues.shiftTml,
                    },
                    {
                        name: 'Catalogues.DaySchedule.NameSingle',
                        path: this.$api.catalogues.daySchedule,
                    },
                ],
            },
            {
                name: 'Catalogues.OrderCustomProperty.NameMultiple',
                path: this.$api.catalogues.orderCustomProperty,
            },
        ],
    };

    private journals = {
        name: 'Main.Journals',
        open: false,
        show: true,
        items: [
            {name: 'Documents.Plan.NameMultiple', path: this.$api.journals.plan},
            {
                name: 'Documents.Order.NameMultiple',
                path: this.$api.journals.order,
            },
            {
                name: 'Documents.Schedule.NameSingle',
                path: this.$api.journals.schedule,
            },
            {
                name: 'Catalogues.EquipmentActivity.NameSingle',
                path: this.$api.journals.scheduleEquipmentActivity,
            },
            {
                name: 'Documents.PlywoodPriceList.NameMultiple',
                path: this.$api.journals.plywoodPriceList,
            },
            {
                name: 'Documents.WarehousePlywoodState.NameMultiple',
                path: this.$api.journals.warehousePlywoodState,
            },
            {
                name: 'Documents.WarehousePlywoodAudit.NameMultiple',
                path: this.$api.journals.warehousePlywoodAudit,
            },
            {
                name: 'Documents.WarehouseVeneerState.NameMultiple',
                path: this.$api.journals.warehouseVeneerState,
            },
            {
                name: 'Documents.WarehouseVeneerAudit.NameMultiple',
                path: this.$api.journals.warehouseVeneerAudit,
            },
        ],
    };

    get administration() {
        const defaultItems = [
            {
                name: 'Systems.Settings.NameMultiple',
                path: this.$api.settings,
            },
            {
                name: 'Systems.User.NameMultiple',
                path: this.$api.administration.user,
            },
            {
                name: 'Systems.Role.NameMultiple',
                path: this.$api.administration.role,
            },
            {
                name: 'Systems.UserRoleLink.NameMultiple',
                path: this.$api.administration.userRoleLink,
            },
            {
                name: 'Systems.RolePolicyLink.NameMultiple',
                path: this.$api.administration.rolePolicyLink,
            },
        ];

        const adminItems = [
            {
                name: 'Systems.Company.NameMultiple',
                path: this.$api.administration.company,
                needDivider: true,
            },
            {
                name: 'Systems.Company.SwitchCompany',
                childrens: this.companies?.map(item => ({
                    noNeedTranslation: true,
                    name: item.Description,
                    on: {
                        click: () => this.changeCompany(item.Id),
                    },
                    class: {
                        'v-list-item--active': item.Id === this.idCurrentCompany,
                    },
                })),
            },
            {
                name: 'Systems.User.NameMultiple',
                path: this.$api.administration.adminUser,
            },
            {
                name: 'Systems.Logging.NameMultiple',
                path: this.$api.administration.logging,
            },
        ];

        return {
            name: 'Main.Administration',
            open: false,
            show: true,
            items: this.isAdmin ? [...defaultItems, ...adminItems] : [...defaultItems],
        };
    }

    get menus() {
        return [this.catalogues, this.journals, this.administration];
    }

    get equipment() {
        if (this.equipmentTypes.length === 0) return [...this.equipmentPiece];
        return [
            ...this.equipmentPiece,
            ...this.equipmentTypes.map((item: any, index: number) => ({
                needDivider: index === 0,
                noNeedTranslation: true,
                name: item.Description,
                route: {
                    path: this.$api.catalogues.equipmentTab,
                    query: {
                        idEquipmentType: item.Id,
                    },
                },
                class: {
                    'v-list-item--active': this.$route.query.idEquipmentType == item.Id,
                },
                props: {
                    exact: true,
                },
            })),
        ];
    }

    @Watch('equipment', {deep: true, immediate: true})
    onPreparedEquipmentTypesChange(value: any) {
        this.catalogues.items[0].childrens = this.equipment as any;
    }
}
